import type { IconData } from '@stacksjs/iconify-core'

export const bq4x3: IconData = {
  "body": "<path fill=\"#21468b\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"M0 0h640v320H0z\"/><path fill=\"#ae1c28\" d=\"M0 0h640v160H0z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default bq4x3
